"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SuggestionFooter = void 0;
var tslib_1 = require("tslib");
var React = tslib_1.__importStar(require("react"));
var SuggestionFooter_st_css_1 = require("./SuggestionFooter.st.css");
var SearchIcon_1 = require("../SearchIcon");
exports.SuggestionFooter = function (_a) {
    var text = _a.text, _b = _a.searchAllText, searchAllText = _b === void 0 ? '{searchAllText}' : _b, _c = _a.searchQuery, searchQuery = _c === void 0 ? '{searchQuery}' : _c, onClick = _a.onClick, props = tslib_1.__rest(_a, ["text", "searchAllText", "searchQuery", "onClick"]);
    var handleClick = function (e) {
        if (onClick) {
            // e is prevented only when onClick is passed from outside,
            // otherwise the click should invoke the default browser behavior from <a href={url}
            e.preventDefault();
            onClick({
                query: searchQuery,
                url: props.url,
            });
        }
    };
    return (React.createElement("a", { href: props.url, "data-hook": "suggestions-search-all", onClick: handleClick, className: SuggestionFooter_st_css_1.st(SuggestionFooter_st_css_1.classes.root), style: {
            height: props.height + "px",
        } },
        React.createElement(SearchIcon_1.SearchIcon, { className: SuggestionFooter_st_css_1.st(SuggestionFooter_st_css_1.classes.icon) }),
        React.createElement("span", { className: SuggestionFooter_st_css_1.st(SuggestionFooter_st_css_1.classes.text) }, text || searchAllText + " \"{" + searchQuery + "}\"")));
};
//# sourceMappingURL=SuggestionFooter.js.map